import { render, staticRenderFns } from "./OtherServiceSelect.vue?vue&type=template&id=5f2a2d66&"
import script from "./OtherServiceSelect.vue?vue&type=script&lang=js&"
export * from "./OtherServiceSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports